import { AttendanceEmployee } from 'generated/resources/graphql'
import moment from 'moment'

import { NavigationParams } from 'modules/attendance/lib/types'

class EmployeeUtils {
  static isActiveInPeriod(
    employee: Pick<AttendanceEmployee, 'terminatedOn'>,
    params: NavigationParams
  ): boolean {
    if (!employee.terminatedOn) return true

    const startDate = moment([
      parseInt(params.year),
      parseInt(params.month) - 1,
      params.day ? parseInt(params.day) : 1,
    ])

    const terminationDate = moment(employee.terminatedOn)

    return terminationDate.isSameOrAfter(startDate)
  }
}

export default EmployeeUtils
